'use client';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TCategoryServices } from '@/services/api/services-api';

const BasicTabsList: React.FC<{ services: TCategoryServices[] }> = ({
  services
}) => {
  return (
    <div className="w-full relative h-16 ">
      <TabsList className="flex absolute h-full ">
        {services.map((category) => (
          <TabsTrigger
            key={category.sport.id}
            value={category.sport.id}
            className="h-full min-w-40"
          >
            {category.sport.name}
          </TabsTrigger>
        ))}
      </TabsList>
    </div>
  );
};

export default BasicTabsList;
